export interface NewUser {
  name: string;
  email: string;
  phoneNumber: string;
}
